import { carouselItems } from '@/mocks/carousel';

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              焦点专题
            </h2>
            <p className="text-sm text-foreground-500 mt-1">本周不容错过的深度内容</p>
          </div>
          <span className="text-xs text-foreground-400 bg-background-100 px-3 py-1.5 rounded-full">
            共 6 个专题
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-background-300 transition-colors group cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] bg-accent-500 text-background-50 px-2 py-1 rounded-full font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{item.hot}</span>
                  <span className="text-xs text-primary-500 font-medium whitespace-nowrap">
                    阅读全文 <i className="ri-arrow-right-line text-[10px]"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}